"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectMeetingAttendee = exports.attendeeScreenShareSelector = void 0;
var _reselect = require("reselect");
var _Sources = require("@studio/constants/Sources");
var _broadcastSourcesSelector = require("./broadcastSourcesSelector");
function selectMeeting(state) {
  return state.meeting || {};
}
var selectMeetingAttendee = exports.selectMeetingAttendee = (0, _reselect.createSelector)(selectMeeting, function (meeting) {
  var _meeting$attendeeResp = meeting.attendeeResponse,
    attendeeResponse = _meeting$attendeeResp === void 0 ? {} : _meeting$attendeeResp;
  var _attendeeResponse$Att = attendeeResponse.Attendee,
    Attendee = _attendeeResponse$Att === void 0 ? {} : _attendeeResponse$Att;
  var _Attendee$AttendeeId = Attendee.AttendeeId,
    meetingAttendeeId = _Attendee$AttendeeId === void 0 ? '' : _Attendee$AttendeeId;
  return meetingAttendeeId;
});
var attendeeScreenShareSelector = exports.attendeeScreenShareSelector = (0, _reselect.createSelector)(_broadcastSourcesSelector.selectBroadcastSources, selectMeetingAttendee, function (broadcastSources, attendee) {
  var attendeeScreenShare = broadcastSources.find(function (source) {
    var _ref = source || {},
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? '' : _ref$type,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value;
    return type === _Sources.SCREEN_PRESENTER && value === "".concat(attendee, "#content");
  });
  return attendeeScreenShare || {};
});